let qs = location.search.slice(1).split('&').reduce((ret, kv) => {
    let [ key, value = '' ] = kv.split('=');
    
    if (key) {
      if (!value) value = true;
      else {
        value = decodeURIComponent(value);
      }
  
      ret[key] = value;
    }
  
    return ret;
  }, {});
  
  const stringify = (qs) => {
    return Object.keys(qs).map(key => `${key}=${encodeURIComponent(qs[key])}`).join('&');
  };
  
  export const appendParams = (url, newParams = {}) => {
    const [ path, qs ] = url.split('?');
  
    if (Object.keys(newParams).length <= 0) {
      return url;
    }
  
    if (qs) {
      return url + '&' + stringify(newParams);
    } else {
      return url + '?' + stringify(newParams);
    }
  };

  
  export default qs;


// WEBPACK FOOTER //
// ./src/util/qs.js